import type { AssetType } from '@repo/types/asset';
import { ApiError, type ApiErrorData } from '@repo/utils';
import { isObject } from '@repo/utils/type.utils';

interface AssetRetrievalErrorData {
    assetType: AssetType;
    error: ApiErrorData;
}

function isAssetRetrievalErrorData(value: unknown): value is AssetRetrievalErrorData {
    return value !== undefined && isObject(value) && 'error' in value && 'assetType' in value;
}

export class AssetRetrievalError extends ApiError {
    constructor(data?: ApiError | Response | number) {
        if (data instanceof ApiError) {
            const errorData = isAssetRetrievalErrorData(data.data) ? data.data.error : data.data;
            super(data.message, data.status, errorData, data.context);
            return;
        }

        const status = typeof data === 'number' ? data : data?.status;
        super('Something went wrong', status, {
            errorCode: 'SOT000',
        });
    }
}
